"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatus = exports.SmallestCurrencyUnit = exports.PaymentMethods = exports.Gender = exports.Currencies = exports.AdminFilterIds = void 0;
var AdminFilterIds;
(function (AdminFilterIds) {
    AdminFilterIds["Categories"] = "categories";
    AdminFilterIds["Featured"] = "featured";
    AdminFilterIds["FromParentTenant"] = "fromParentTenant";
    AdminFilterIds["PublishedItems"] = "publishedItems";
})(AdminFilterIds = exports.AdminFilterIds || (exports.AdminFilterIds = {}));
/**
 * All items in this list should be ISO-4217 compliant.
 */
var Currencies;
(function (Currencies) {
    Currencies["Euro"] = "EUR";
    Currencies["BrazilianReal"] = "BRL";
})(Currencies = exports.Currencies || (exports.Currencies = {}));
var Gender;
(function (Gender) {
    Gender["female"] = "female";
    Gender["male"] = "male";
})(Gender = exports.Gender || (exports.Gender = {}));
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["StripePT"] = "stripe-pt";
    PaymentMethods["StripeBR"] = "stripe-br";
})(PaymentMethods = exports.PaymentMethods || (exports.PaymentMethods = {}));
exports.SmallestCurrencyUnit = {
    BRL: 0.01,
    EUR: 0.01,
};
Object.freeze(exports.SmallestCurrencyUnit);
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Done"] = "done";
    OrderStatus["Cancelled"] = "cancelled";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
//# sourceMappingURL=enums.js.map